import { Button } from '@/components/atoms/Button/Button.styled';
import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const SelectedFiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  grid-row-start: 1;
  grid-column: 1 / -1;
  padding: 0;
  height: var(--filter-row-height);
  // recentramos con margin y pseudoelemento para poder calcular la altura
  margin-top: calc(var(--spacing-component-inner) * -1);
  overflow: hidden;
  transition: opacity var(--tr-base);

  // sirve para añadir espacio y calcular la altura:
  &:before,
  &:after {
    content: '';
    position: relative;
    display: block;
    width: 100%;
    height: var(--spacing-component-inner);
  }

  &[data-is-displayed='false'] {
    opacity: 0;
    pointer-events: none;
    height: 0;
  }

  ${medias.only.tablet} {
    position: absolute;
    margin-top: -40px;
    width: 50%;
    left: 50%;
  }

  ${Button} {
    margin-right: var(--spacing-component-inner-sm);

    p {
      transition: color var(--tr-base);
    }

    &:hover {
      p {
        color: var(--c-font-primary);
      }

      img {
        opacity: 1 !important;
      }
    }

    img {
      opacity: 0.6 !important;
      transition: opacity var(--tr-base);
    }
  }
`;
